import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LoadingService } from "@coso/loading";
import { Observable } from "rxjs";
import { SettingsService } from "../services/settings.service";

@Component({
  standalone:false,
  selector: "coso-replicator-page-header",
  templateUrl: "./page-header.component.html",
  styleUrls: ["./page-header.component.scss"],
})
export class PageHeaderComponent implements OnInit {
  hasSettingsChanged$: Observable<boolean>;

  @Input() title: string;

  constructor(public loadingService: LoadingService, private route: ActivatedRoute, private settingsService: SettingsService) {}

  ngOnInit(): void {
    const instanceId = this.route.snapshot.paramMap.get("instance-id");
    this.hasSettingsChanged$ = this.settingsService.hasChangedWhileRunning(instanceId);
  }
}
